import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5c64f7dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "column" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = {
  viewBox: "0 0 100 100",
  class: "flag-icon"
}
const _hoisted_4 = ["xlink:href"]
const _hoisted_5 = { class: "title-block" }
const _hoisted_6 = { class: "name" }
const _hoisted_7 = { class: "type" }
const _hoisted_8 = { class: "metrics" }
const _hoisted_9 = { class: "metric" }
const _hoisted_10 = { class: "metric-label" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "CPU", -1))
const _hoisted_12 = ["aria-valuenow"]
const _hoisted_13 = { class: "metric" }
const _hoisted_14 = { class: "metric-label" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "内存", -1))
const _hoisted_16 = ["aria-valuenow"]
const _hoisted_17 = { class: "metric" }
const _hoisted_18 = { class: "metric-label" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "硬盘", -1))
const _hoisted_20 = ["aria-valuenow"]
const _hoisted_21 = {
  key: 0,
  class: "metric"
}
const _hoisted_22 = { class: "metric-label" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "本月流量", -1))
const _hoisted_24 = ["aria-valuenow"]
const _hoisted_25 = { class: "traffic-meta" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = {
  key: 2,
  class: "traffic-hint"
}
const _hoisted_29 = { key: 3 }
const _hoisted_30 = { class: "card-info" }
const _hoisted_31 = { class: "info-item" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "k" }, "↓ 速率", -1))
const _hoisted_33 = { class: "v" }
const _hoisted_34 = { class: "info-item" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "k" }, "↑ 速率", -1))
const _hoisted_36 = { class: "v" }
const _hoisted_37 = { class: "info-item" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "k" }, "↓ 流量", -1))
const _hoisted_39 = { class: "v" }
const _hoisted_40 = { class: "info-item" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "k" }, "↑ 流量", -1))
const _hoisted_42 = { class: "v" }
const _hoisted_43 = { class: "info-item" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "k" }, "负载", -1))
const _hoisted_45 = { class: "v" }
const _hoisted_46 = { class: "info-item" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "k" }, "在线", -1))
const _hoisted_48 = { class: "v" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["ui fluid card sakura-card", { offline: !_ctx.getStatus }])
    }, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(), _createElementBlock("svg", _hoisted_3, [
          _createElementVNode("use", {
            "xlink:href": `#${_ctx.server.region}`
          }, null, 8, _hoisted_4)
        ])),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.server.name), 1),
          _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.server.type), 1)
        ]),
        _createElementVNode("span", {
          class: _normalizeClass(["status-badge", { on: _ctx.getStatus }])
        }, _toDisplayString(_ctx.getStatus ? '在线' : '离线'), 3)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("span", null, _toDisplayString(_ctx.getStatus ? `${_ctx.getCpuStatus}%` : '–'), 1)
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["ui tiny progress", _ctx.getProcessBarStatus(_ctx.getCpuStatus)]),
            role: "progressbar",
            "aria-label": "CPU 使用率",
            "aria-valuenow": _ctx.getStatus ? _ctx.getCpuStatus : 0,
            "aria-valuemin": "0",
            "aria-valuemax": "100"
          }, [
            _createElementVNode("div", {
              class: "bar",
              style: _normalizeStyle({ width: _ctx.getStatus ? `${_ctx.getCpuStatus}%` : '0%' })
            }, null, 4)
          ], 10, _hoisted_12)
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("span", null, _toDisplayString(_ctx.getStatus ? `${_ctx.getRAMStatus}%` : '–'), 1)
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["ui tiny progress", _ctx.getProcessBarStatus(_ctx.getRAMStatus)]),
            role: "progressbar",
            "aria-label": "内存使用率",
            "aria-valuenow": _ctx.getStatus ? _ctx.getRAMStatus : 0,
            "aria-valuemin": "0",
            "aria-valuemax": "100"
          }, [
            _createElementVNode("div", {
              class: "bar",
              style: _normalizeStyle({ width: _ctx.getStatus ? `${_ctx.getRAMStatus}%` : '0%' })
            }, null, 4)
          ], 10, _hoisted_16)
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _createElementVNode("span", null, _toDisplayString(_ctx.getStatus ? `${_ctx.getHDDStatus}%` : '–'), 1)
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["ui tiny progress", _ctx.getProcessBarStatus(_ctx.getHDDStatus)]),
            role: "progressbar",
            "aria-label": "硬盘使用率",
            "aria-valuenow": _ctx.getStatus ? _ctx.getHDDStatus : 0,
            "aria-valuemin": "0",
            "aria-valuemax": "100"
          }, [
            _createElementVNode("div", {
              class: "bar",
              style: _normalizeStyle({ width: _ctx.getStatus ? `${_ctx.getHDDStatus}%` : '0%' })
            }, null, 4)
          ], 10, _hoisted_20)
        ]),
        (_ctx.traffic.tracked)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _hoisted_23,
                _createElementVNode("span", null, _toDisplayString(_ctx.trafficValue), 1)
              ]),
              (_ctx.traffic.limited)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["ui tiny progress", _ctx.traffic.level]),
                    role: "progressbar",
                    "aria-label": "本月流量用量",
                    "aria-valuenow": _ctx.traffic.percent,
                    "aria-valuemin": "0",
                    "aria-valuemax": "100"
                  }, [
                    _createElementVNode("div", {
                      class: "bar",
                      style: _normalizeStyle({ width: `${_ctx.traffic.percent}%` })
                    }, null, 4)
                  ], 10, _hoisted_24))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_25, [
                (_ctx.traffic.limited)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(_ctx.traffic.state === 'offline' ? '–' : _ctx.tableRowByteConvert(_ctx.traffic.used)) + " / " + _toDisplayString(_ctx.tableRowByteConvert(_ctx.traffic.limit)), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_27, "不限额")),
                (_ctx.trafficHint)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(_ctx.trafficHint), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(_ctx.traffic.daysLeft) + " 天后重置", 1))
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_30, [
        _createElementVNode("div", _hoisted_31, [
          _hoisted_32,
          _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.getStatus ? `${_ctx.tableRowByteConvert(_ctx.server.network_rx)}/s` : '–'), 1)
        ]),
        _createElementVNode("div", _hoisted_34, [
          _hoisted_35,
          _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.getStatus ? `${_ctx.tableRowByteConvert(_ctx.server.network_tx)}/s` : '–'), 1)
        ]),
        _createElementVNode("div", _hoisted_37, [
          _hoisted_38,
          _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.getStatus ? _ctx.tableRowByteConvert(_ctx.server.network_in) : '–'), 1)
        ]),
        _createElementVNode("div", _hoisted_40, [
          _hoisted_41,
          _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.getStatus ? _ctx.tableRowByteConvert(_ctx.server.network_out) : '–'), 1)
        ]),
        _createElementVNode("div", _hoisted_43, [
          _hoisted_44,
          _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.getStatus ? _ctx.server.load : '–'), 1)
        ]),
        _createElementVNode("div", _hoisted_46, [
          _hoisted_47,
          _createElementVNode("span", _hoisted_48, _toDisplayString(_ctx.server.uptime || '–'), 1)
        ])
      ])
    ], 2)
  ]))
}